import { use_slice_search } from '@/hooks/store/use_slices';
import { ViewWithPermissionsOrBarBackground } from '@/pages/_base/views/ViewWithPermissionsOrBarBackground';
import { md } from '@/utils/utils_html';
import { ENUM__workspace_entity_feature } from '@shared/dto/+workspace/workspace_entity/_enums/ENUM__workspace_entity_feature';
import { STokensList } from '../prompt_tokens_list/STokensList';
import { SPromptInput } from './SPromptInput';

export function SPromptBar() {
  const { search_current } = use_slice_search(['search_current']);

  function render_view() {
    return (
      <div className={`${md('p-2 bg-component rounded-lg flex-1', '')}`}>
        <SPromptInput />
        <div className="w-full h-[calc(100%-40px)] overflow-y-auto">
          <STokensList />
        </div>
      </div>
    );
  }

  return (
    <ViewWithPermissionsOrBarBackground view={render_view()} entity={search_current} required_permission={ENUM__workspace_entity_feature.ENTITY_SEARCH_VIEW} />
  );
}
